import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(response => response, error => {
  const token = localStorage.getItem('token');
  if (error.response?.status === 401 && token &&
      error.config?.headers?.Authorization === `Bearer ${token}` &&
      error.config?.url !== '/auth/login') {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    window.dispatchEvent(new Event('session-expired'));
  }
  return Promise.reject(error);
});

export default api;
